import { render, staticRenderFns } from "./complaintsDashboard.vue?vue&type=template&id=046c819c&scoped=true"
import script from "./complaintsDashboard.vue?vue&type=script&lang=js"
export * from "./complaintsDashboard.vue?vue&type=script&lang=js"
import style0 from "./complaintsDashboard.vue?vue&type=style&index=0&id=046c819c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c819c",
  null
  
)

export default component.exports